<template>
  <div>
    <transition name="media-scale">
      <div v-show="isMaxDialog && isShowCurt" class="media-scale">
        <el-dialog
          v-bind="$attrs"
          v-on="$listeners"
          :key="'dialog'"
          :visible="isShowCurt"
          :modal="false"
          :close-on-click-modal="false"
          :title = "$t('multimedia.多媒体')"
          width="760px"
          class="dialog-dark multimedia-container"
          @open="onOpen"
          @close="onClose"
        >
          <div v-if="role !== 1" class="mini-btn" @click="isMaxDialog = false">
            <i class="iconfont icon-mini"></i>
          </div>
          <div class="upload-box">
            <Upload
              ref="upload"
              :mode="1"
              :bind="2"
              :fileTypes="fileTypes"
              :fileSize="4096"
              @change="onChange"
              @on-error="onError"
            >
              <el-button
                :disabled="limit >= 20"
                class="button-mini"
                size="mini"
                type="primary"
                >{{$t('multimedia.添加文件')}}</el-button
              >
            </Upload>
            <div class="upload-accept">
              {{$t('multimedia.格式')}}：flv、wmv、avi、mp4、mov、mkv、mp3、wav、flac，{{$t('multimedia.大小')}}：≤4G，{{$t('multimedia.数量')}}：≤20{{$t('multimedia.个')}}
            </div>
          </div>
          <div class="gap-line"></div>
          <el-table
            ref="tableRef"
            :data="tableData"
            :show-header="tableData.length > 0"
            class="
              table-dark table-noborder table-no-header-bg
              el-table--scrollable-y
              npl
            "
            highlight-current-row
            size="small"
          >
            <el-table-column prop="title" :label = "$t('multimedia.文件名称')">
              <template slot-scope="scope">
                <div :class="{ 'is-play': getIsPlay(scope.row) }">
                  <TextTip
                    :text="scope.row.filename"
                    :width="280"
                    :suffix="true"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              :label = "$t('multimedia.状态')"
              width="200"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.style === 'prepare'"
                  class="is-play"
                >
                  {{$t('multimedia.上传中')}}
                </div>
                <div
                  v-if="scope.row.style === 'uploading'"
                  class="is-play"
                >
                  {{ scope.row.percent }}
                </div>
                <div v-if="scope.row.style === 'complete'" style="color: #fff">
                  {{$t('multimedia.成功')}}
                </div>
                <div v-if="scope.row.style === 'fail'" style="color: #ea494b">
                  {{$t('multimedia.上传失败')}}
                </div>
                <div
                  v-if="scope.row.style === 'transcoding'"
                  class="is-play"
                >
                  {{ scope.row.percent }}
                </div>
                <div
                  v-if="scope.row.style === 'transcodingFail'"
                  style="color: #ea494b"
                >
                  {{$t('multimedia.转码失败')}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="role === 3"
              :label = "$t('multimedia.操作')"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <!-- <template v-if="scope.row.style === 'fail'">
                  <el-link
                    v-if="scope.row.file"
                    :underline="false"
                    class="reupload-btn"
                    type="primary"
                    @click="reupload(scope.row)"
                  >
                    <i class="iconfont icon-reupload"></i>
                  </el-link>
                </template> -->
                <template v-if="scope.row.style === 'complete'">
                  <el-link
                    v-if="!getIsPlay(scope.row)"
                    :disabled="scope.row.style !== 'complete' || !avctl"
                    :underline="false"
                    type="primary"
                    @click="play(scope.row)"
                  >
                    <el-tooltip
                      effect="dark"
                      :content = "$t('multimedia.需要获取主控权')"
                      placement="top"
                      :disabled="avctl === 1"
                    >
                      <i class="iconfont icon-play"></i>
                    </el-tooltip>
                  </el-link>
                  <el-link
                    v-else
                    :disabled="!avctl"
                    :underline="false"
                    type="primary"
                    @click="onEnd"
                  >
                    <el-tooltip
                      effect="dark"
                      :content = "$t('multimedia.需要获取主控权')"
                      placement="top"
                      :disabled="avctl === 1"
                    >
                      <i class="iconfont icon-end1"></i>
                    </el-tooltip>
                  </el-link>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="role === 3 ? '' : this.$t('multimedia.操作')" width="120">
              <template slot-scope="scope">
                <el-popconfirm
                  :title = "$t('multimedia.你确定要删除该文件吗')"
                  popper-class="tip-popconfirm"
                  icon="el-icon-info"
                  icon-color="#EA494B"
                  @confirm="docDel(scope.row, scope.$index)"
                >
                  <el-button
                    v-show="
                      !(
                        scope.row.style === 'prepare' ||
                        scope.row.style === 'uploading' ||
                        scope.row.style === 'transcoding'
                      )
                    "
                    :disabled="getIsPlay(scope.row)"
                    :underline="false"
                    class="delete-btn"
                    type="text"
                    slot="reference"
                  >
                    <i class="iconfont icon-delete"></i>
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
            <Blank
              :src="duomeitiImg"
              :width="160"
              :height="150"
              slot="empty"
              :text = "$t('multimedia.暂无多媒体')"
            />
          </el-table>
          <div
            v-show="avctl"
            class="control-footer"
            slot="footer"
          >
            <div class="media-mute" v-show="!(current && isPush)">
              {{$t('multimedia.媒体播放时全员静音')}}
              <el-switch class="switch--mini" :width="28" :value="liveConfig.liveondemandVoiceStatus === 0" @change="mediaMuteChange"></el-switch>
              <span class="media-mute__text">{{$t('multimedia.注')}}</span>
            </div>
            <MediaControl
              v-show="current && isPush"
              ref="control"
              :current-time.sync="currentTime"
              :current-volume.sync="currentVolume"
              :mute.sync="isMute"
              :duration="duration"
              :showPlay="true"
              :showLoop="true"
              :loop="isLoop"
              @play="onPlay"
              @pause="onPause"
              @end="onEnd"
              @change="onChangeTime"
              @volumeChange="onChangeVolume"
              @loop="onLoop"
            />
          </div>
        </el-dialog>
      </div>
    </transition>
    <transition name="media-scale">
      <div v-show="isShowCurt && !isMaxDialog" class="media-scale">
        <MultiMediaMini
          v-drag
          :key="'mini'"
          :current-time.sync="currentTime"
          :current-volume.sync="currentVolume"
          :mute.sync="isMute"
          :duration="duration"
          :title="currentTitle"
          :status="$refs.control && $refs.control.isPlay"
          @play="onPlay"
          @pause="onPause"
          @end="onEnd"
          @close="onClose"
          @volumeChange="onChangeVolume"
          @screen="isMaxDialog = true"
        />
      </div>
    </transition>
  </div>
</template>
<script>
import { Dialog, Link, Popconfirm, Table, TableColumn } from "element-ui";
import Upload from "@/components/upload";
import MediaControl from "@/components/media/control";
import MultiMediaMini from "./multimedia-mini";
import { getDetail, startPlay } from "@/api/incurtRequest/api";
import { mediaRoomMute } from "@/api/liveRequest/liveInfo";
import { getParameter, getSeqId } from "@/utils/global";
import {
  pushRoomMessageFunc,
  // removeMessageFunc,
} from "@/utils/socketMessageDispose";
import { getUrl } from "@/api/docRequest/api";
import { mapGetters } from "vuex";
import Blank from "@/components/blank";
import duomeitiImg from "@/assets/images/blank/duomeiti.png";
import TextTip from "@/components/textTip";
import Role from "@/mixins/role";
import aw from "@/utils/aw";
import Bus from "@/components/doc/bus";
import ElTooltip from "@/components/tooltip/ElTooltip";
export default {
  name: "Multimedia",
  components: {
    ElTooltip,
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Link.name]: Link,
    [Popconfirm.name]: Popconfirm,
    Upload,
    MediaControl,
    MultiMediaMini,
    Blank,
    TextTip,
  },
  mixins: [Role],
  data() {
    return {
      duomeitiImg,
      // 是否正在推流
      isPush: false,
      roomId: getParameter("roomId"),
      liveId: getParameter("liveId"),
      tableData: [],
      current: undefined,
      currentTime: 0,
      duration: 0,
      isMaxDialog: true,
      isLoop: false,
      timer: undefined,
      isChangehost: false,
      isPlay: false,
      isBindEvent: false,
      fileTypes: [
        "flv",
        "wmv",
        "avi",
        "mp4",
        "mov",
        "mkv",
        "mp3",
        "wav",
        "flac",
      ],
      currentVolume: 100,
      isMute: false,
      mediaMute: false,
      isCB: false,
    };
  },
  computed: {
    ...mapGetters([
      "isShowCurt",
      "rtcClient",
      "shareType",
      "userInfo",
      "liveToken",
      "liveConfig",
      "selfParticipant"
    ]),
    audioStatus() {
      return this.selfParticipant?.mediaStatus?.audio || "disabled";
    },
    currentTitle() {
      return this.current ? this.current.name : "";
    },
    limit() {
      return this.tableData.filter((v) => v.style !== "fail")?.length || 0;
    },
    shareStream() {
      return this.rtcClient?.RTCRoom?.shareStream;
    },
    updateWatch() {
      return [this.shareStream?.type === "streaming", this.liveToken, this.audioStatus === "active"]
    }
  },
  watch: {
    isPlay() {
      this.updateTime();
    },
    updateWatch: {
      immediate: true,
      handler(n){
        console.log("updateWatch n", n);
        if (n[1] || n[2]) {
          console.log("updateWatch getDetail",);
          this.getDetail();
        }
        if (n[1] && n[0]) {
          this.getVolume();
        }
      }
    },
    avctl: {
      immediate: true,
      handler(n) {
        if (n) {
          this.changehost();
        } else {
          this.isChangehost = false;
        }
      },
    },
    isMaxDialog(n) {
      if (n) {
        this.getList();
      }
    },
  },
  created() {
    console.log('media created');
    if (!this.isBindEvent) {
      this.isBindEvent = true;
      pushRoomMessageFunc(this.message_event);
    }
  },
  mounted() {
    Bus.$on("pse:end:media", async (resolve) => {
      if (!this.current) {
        return resolve();
      }
      // console.log("........................");
      await this.onEnd();
      resolve();
    });
  },
  methods: {
    message_event({ cmd, requestData }) {
      switch (cmd) {
        case 7107:
          this.message_7107(requestData);
          break;
      }
    },
    message_7107(body) {
      switch (body.cmd) {
        case 3079:
          this.$refs.upload?.transcodingFile(body);
          break;
        case "6001":
          this.message_7107_6001(body);
          break;
      }
    },
    message_7107_6001() {
      console.log('message_7107_6001 getDetail')
      this.getDetail();
    },
    // 弹窗打开
    onOpen() {
      console.log("open getDetail")
      this.getDetail();
      this.setReportInfo();
      this.getList();
    },
    // 关闭弹窗
    onClose() {
      this.$store.commit("SET_SHOW_INCURT", false);

      this.clearTimer();
      setTimeout(() => {
        this.isMaxDialog = true;
      }, 10);
    },
    // 更新文件列表
    onChange(files) {
      this.tableData = files;
    },
    // 文件上传错误
    onError({ type, msg }) {
      switch (type) {
        case "fileSize":
          this.$message.error(this.$t('multimedia.文件大小不能超过'));
          break;
        case "fileType":
          this.$message.error(this.$t('multimedia.文件格式错误'));
          break;
        case "fileDel":
          this.$message.error(msg);
          break;
        case "fileBind":
          this.$message.error(msg);
          break;
        case "leftSize":
          this.$alert(this.$t('multimedia.您的账号存储空间不足，请尽快与服务人员联系'), {
            title: this.$t('multimedia.提示'),
            customClass: "tip-alert text-left",
            confirmButtonText: this.$t('multimedia.我知道了'),
          });
          break;
      }
    },
    getList() {
      this.$nextTick(() => {
        this.$refs.upload?.updateFiles();
      });
    },
    async setReportInfo() {
      const data = {
        action: "setreportinfo",
        platform: "cloud",
        webcastId: this.liveId,
        meetId: this.roomId,
        to: "all",
        cmd: "6001",
        seqid: getSeqId(),
      };
      const { results } = await startPlay(this.roomId, data);
      if (results === "failed") {
        this.$message.error(this.$t('multimedia.设置通知失败'));
        return;
      }
    },
    async play(item) {
      // TODO:
      if (this.shareType == 4) {
        return this.$message.warning(this.$t('multimedia.当前正在播放伪直播，不允许发起插播'));
      }
      const tip = (tip) => {
        return aw(
          this.$confirm(tip, {
            title: this.$t('multimedia.提示'),
            customClass: "tip-alert text-left",
            confirmButtonText: this.$t('multimedia.我知道了'),
          })
        );
      };
      // streaming 插播 webrtc 共享
      if (this.shareStream?.type === "webrtc") {
        const [err] = await tip(
          this.$t('multimedia.当前正在进行共享')
        );
        if (err !== null) return;
        console.log("关闭共享")
        Bus.$emit("closeShare");
        Bus.$emit("closeShareBtn");
      }
      this.getUrl(item);
    },
    // 开始播放
    onPlay(type) {
      this.startCall("resume");
      if (type === "mini") {
        this.$refs.control?.play();
      }
    },
    // 暂停
    onPause(type) {
      this.startCall("pause");
      if (type === "mini") {
        this.$refs.control?.pause();
      }
    },
    // 结束
    async onEnd() {
      console.log("onend stoplive");
      await this.startCall("stoplive");
    },
    // 更新循环状态
    onLoop(loop) {
      this.isLoop = loop;
      if (!this.current) return;
      const { id, name, url } = this.current;
      this.startPlay(
        {
          srcFileId: id,
          filename: name,
        },
        url,
        true
      );
    },
    // 删除文档
    docDel(item, index) {
      this.$refs.upload.delFile(item, index);
    },
    // 重新上传
    reupload(item) {
      if (item.file) {
        this.$refs.upload.computeMD5(item);
      }
    },
    // 获取当前文件是否为播放
    getIsPlay(item) {
      return this.current && item.srcFileId === this.current?.id;
    },
    // seek
    onChangeTime() {
      this.startSeek(this.currentTime);
    },
    onChangeVolume(size) {
      console.log(size, "this.currentVolume");
      this.rtcClient.RTCRoom.setInterCutVolume({
        size: size !== undefined ? size : this.currentVolume,
      });
      if (size === 0) {
        this.isMute = true;
      } else {
        this.isMute = false;
      }
      // this.currentVolume = size? size:this.currentVolume;
    },
    async getVolume() {
      const volume = await this.rtcClient.RTCRoom.getInterCutVolume();
      this.currentVolume = volume.data.size;
      if (this.currentVolume === 0) {
        this.isMute = true;
      } else {
        this.isMute = false;
      }
    },
    // 获取插播详情
    async getDetail() {
      console.log('获取插播详情')
      const { results, status, records, duration, timestamp, totalloopnum } =
        await getDetail(this.roomId);
      this.isPlay = false;
      if (results === "failed" || status === 0) {
        this.$refs.control?.end();
        this.stoplive();
        this.$store.commit("SET_MEDIASTATUS", -1);
        this.isCB = false
        return;
      }
      // if (status === 0) {
      //   this.clearTimer();
      //   return;
      // }
      this.isLoop = totalloopnum !== 0;
      if ([2, 3].includes(status)) {
        this.isPush = true;
        this.current = records[0];
        this.duration = duration / 1000;
        this.currentTime = timestamp / 1000;
      } else {
        this.isCB = false
      }
      // 播放状态，0表示准备中，还在下载中，1表示准备好了可以播放，2表示播放，3表示暂停，4表示停止，5表示异常
      if (status === 2) {
        this.$store.commit("SET_SHARE_TYPE", 3);
        if (this.liveConfig?.liveondemandVoiceStatus === 0 && this.audioStatus == "active") {
          if (!this.isCB) {
            this.$message.warning(this.$t('lianmai.插播全员静音中'))
          }
          this.isCB = true
        }

        if (!this.isPlay) {
          this.$refs.control?.play();
          this.isPlay = true;
        }
      }
      if (status === 3) {
        this.$refs.control?.pause();
      }
      if (status === 4) {
        this.$store.commit("SET_SHARE_TYPE", -1);
      }
      this.$store.commit("SET_MEDIASTATUS", status);
    },
    // 获取播放文件
    async getUrl(item) {
      const [err, { status, data }] = await aw(getUrl(item.srcFileId));
      if (err) {
        this.$message.error(this.$t('multimedia.获取播放地址失败'));
        return;
      }
      if (status === 0) {
        if (this.current && this.current.url) {
          this.rtcClient.RTCRoom.StopPullStreamToMeet();
        }

        this.startPlay(item, data);
      }
    },
    async changehost() {
      const data = {
        action: "changehost",
        uid: this.userInfo.uid,
        cid: this.userInfo.cid,
        flag: 1,
        seqid: getSeqId(),
      };
      const { results } = await startPlay(this.roomId, data);
      if (results === "failed") {
        this.$message.error(this.$t('multimedia.设置权限失败'));
        return;
      }
      if (this.shareStream?.type === "streaming") {
        this.getVolume();
      }
      this.isChangehost = true;
    },
    // 开始播放
    // http://x.lmshao.cn/chabo/TheHobbit-1080p-80s.mp4 和http://x.lmshao.cn/chabo/TheHobbit-1080p-1800s.mp4
    async startPlay(item, aurl, isArg) {
      if (!this.avctl) return;
      !this.isChangehost && (await this.changehost());

      const current = {
        url: aurl,
        name: item.filename,
        id: item.srcFileId,
      };
      const params = {
        action: "play",
        records: [current],
        nowplayseq: 0,
        looporder: [0],
        totalloopnum: this.isLoop ? -1 : 0,
        seqid: getSeqId(),
      };
      const { results, url } = await startPlay(this.roomId, params);
      if (results === "failed") {
        this.$message.error(this.$t('multimedia.播放失败'));
        return;
      }
      if (!isArg) {
        this.rtcClient.RTCRoom.pullStreamToMeet({
          url,
          video: true,
          audio: true,
          muted: this.liveConfig?.liveondemandVoiceStatus === 0
        });
      }
    },
    // 暂停
    async startCall(action) {
      if (!this.avctl) return;
      !this.isChangehost && (await this.changehost());
      const params = {
        action,
        recordurl: this.current.url,
        seqid: getSeqId(),
      };
      const { results } = await startPlay(this.roomId, params);
      if (results === "failed") {
        return;
      }
      if (action === "stoplive") {
        console.log("startCall 执行 stopLive");
        this.stoplive();
      }
    },
    stoplive() {
      this.isPush = false;
      this.current = null;
      this.isCB = false;
      // this.rtcClient?.RTCRoom?.StopPullStreamToMeet();
      console.log("执行 stoplive");
      //if(this.current && this.current.url){
      if(this.shareType === 3) {
        this.$store.commit("SET_SHARE_TYPE", -1);
      }
      //}
    },
    // 发送seek请求
    async startSeek(seektime) {
      if (!this.avctl) return;
      !this.isChangehost && (await this.changehost());
      const params = {
        action: "seek",
        recordurl: this.current.url,
        seektime: seektime * 1000,
        seqid: getSeqId(),
      };
      const { results, realseektime } = await startPlay(this.roomId, params);
      if (results === "failed") {
        return;
      }
      this.realseektime = realseektime / 1000;
      console.log("seek getDetail");
      this.getDetail();
    },
    // 5s校队时间
    updateTime() {
      this.clearTimer();
      this.$nextTick(() => {
        if (this.isPlay) {
          this.timer = setInterval(() => {
            if (this.isShowCurt) {
              console.log("updateTime getDetail");
              this.getDetail();
            }
          }, 5000);
        }
      });
    },
    // 清除定时器
    clearTimer() {
      this.timer && clearInterval(this.timer);
      this.timer = null;
    },
    async mediaMuteChange(e) {
      const { code, msg } = await mediaRoomMute(e ? 0 : 1, this.liveToken)
      if (code !== 200) {
        this.$message.error(msg)
      }
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-link.el-link--primary.is-disabled {
    color: #5b5d66;
  }
  .el-dialog__footer {
    height: 60px;
  }
  .el-table__body-wrapper {
    height: 232px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
.upload-box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.upload-accept {
  margin-left: 30px;
  font-size: 12px;
  color: #8a8f99;
}
.gap-line {
  margin-bottom: 20px;
  height: 1px;
  background-color: #292c51;
}
.delete-btn {
  padding: 0;
  color: #acb2bf;
  &.is-disabled {
    color: #5b5d66;
  }
}
.reupload-btn {
  color: #acb2bf;
}
.mini-btn {
  position: absolute;
  top: 19px;
  right: 54px;
  color: #727480;
  line-height: 1;
  cursor: pointer;
  .icon-mini {
    font-size: 14px;
  }
}
.control-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  ::v-deep {
    .control {
      background: rgba(26, 30, 44, 0.6);
    }
  }
}
.is-play {
  color: #3986ee;
}
.is-can-play {
  color: #3986ee;
}
.is-not-current {
  color: #acb2bf;
}
.media-scale {
  opacity: 1;
  transition: all 0s;
}
.media-scale-enter,
.media-scale-leave-to {
  opacity: 0;
  width: 0;
}
.media-mute {
  display: flex;
  align-items: center;
  padding: 20px 30px;
  font-size: 14px;
  color: #fff;
}
.media-mute__text {
  font-size: 12px;
  color: #ACB2BF;
}
.switch--mini {
  margin: 0 20px;
}
</style>
